import {defineNuxtPlugin, useNuxtApp} from "nuxt/app"
import type {PiniaPluginContext} from 'pinia'

function MyPiniaPlugin({store}: PiniaPluginContext) {
    store.$subscribe((mutation) => {
        try {
            if (mutation.storeId === 'auth') {
                if (store.$state.abilities) {
                    useNuxtApp().$ability.update(store.$state.abilities.map(function (ability: any) {
                        return {
                            action: ability.action,
                            subject: ability.subject
                        }
                    }))
                } else {
                    useNuxtApp().$ability.update([])
                }
            }
        } catch (e) {
            console.log(e)
        }
    })

    // Note this has to be typed if you are using TS
    return {creationTime: new Date()}
}

export default defineNuxtPlugin(nuxtApp => {
    //@ts-expect-error
    nuxtApp.$pinia.use(MyPiniaPlugin)
})